// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imageNodeView {\n  display: inline-flex;\n  position: relative;\n  cursor: pointer;\n}\n.imageNodeView__imageEl {\n  box-shadow: 0px 0px 0px 2px transparent;\n  padding: 4px;\n  border-radius: 3px;\n}\n.imageNodeView__imageEl.-selected {\n  box-shadow: 0px 0px 0px 2px #3378ED;\n}\n.imageNodeView__fakeSelector {\n  position: absolute;\n  border: 0;\n  user-select: all;\n  pointer-events: none;\n  left: 0;\n  right: 0;\n  padding: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
